import * as React from 'react'
import { connect } from 'react-redux'
import { CallbackComponent } from 'redux-oidc'
import { push } from 'connected-react-router'
import userManager from '../utils/userManager'

const CallbackPage: React.FC = (props: any) => {
  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={(user: any) => {
        props.push(user.state)
        if (window.setIdentity) {
          window.setIdentity(user)
        }
      }}
      errorCallback={(error: any) => {
        props.push('/')
      }}
    >
      <div>Redirecting...</div>
    </CallbackComponent>
  )
}

export default connect(null, { push })(CallbackPage)
